(() => {
  const root = document.querySelector('[data-talleria-home]');
  if (!root) return;

  root.classList.add('js-ready');

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const videos = Array.from(root.querySelectorAll('[data-autoloop-video]'));
  const userPaused = new WeakSet();

  const findToggle = (video) => {
    const container = video.closest('.th-hero, .th-video');
    return container ? container.querySelector('[data-video-toggle]') : null;
  };

  const setToggleState = (video, playing) => {
    const toggle = findToggle(video);
    if (!toggle) return;
    toggle.setAttribute('aria-pressed', playing ? 'false' : 'true');
    toggle.setAttribute('aria-label', playing ? 'Pausar vídeo' : 'Reanudar vídeo');
  };

  const syncVideos = () => {
    videos.forEach((video) => {
      video.muted = true;
      video.defaultMuted = true;
      video.volume = 0;
      video.loop = true;
      video.controls = false;
      if (userPaused.has(video)) {
        video.pause();
        setToggleState(video, false);
        return;
      }
      if (reduceMotion.matches || document.hidden) {
        video.pause();
      } else {
        const attempt = video.play();
        if (attempt && typeof attempt.catch === 'function') attempt.catch(() => {});
      }
      setToggleState(video, !video.paused);
    });
  };

  videos.forEach((video) => {
    const toggle = findToggle(video);
    if (!toggle) return;
    toggle.addEventListener('click', () => {
      if (video.paused) {
        userPaused.delete(video);
        const attempt = video.play();
        if (attempt && typeof attempt.catch === 'function') attempt.catch(() => {});
      } else {
        userPaused.add(video);
        video.pause();
      }
      setToggleState(video, !video.paused);
    });
  });

  requestAnimationFrame(() => root.classList.add('is-loaded'));
  syncVideos();
  document.addEventListener('visibilitychange', syncVideos);
  reduceMotion.addEventListener?.('change', syncVideos);

  // Scroll reveal: fade + rise + blur, staged via IntersectionObserver
  const revealTargets = Array.from(root.querySelectorAll('[data-reveal]'));
  if (revealTargets.length && 'IntersectionObserver' in window) {
    const revealObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-in');
          revealObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.2, rootMargin: '0px 0px -8% 0px' });
    revealTargets.forEach((el) => revealObserver.observe(el));
  } else {
    revealTargets.forEach((el) => el.classList.add('is-in'));
  }

  // Subtle parallax on the hero video, transform-only for compositor-friendly scroll
  const parallaxEl = root.querySelector('[data-parallax]');
  if (parallaxEl && !reduceMotion.matches) {
    let ticking = false;
    const updateParallax = () => {
      const rect = parallaxEl.parentElement.getBoundingClientRect();
      const progress = Math.min(1, Math.max(0, 1 - rect.bottom / (rect.height + window.innerHeight)));
      parallaxEl.style.transform = `translateY(${progress * 60}px) scale(${1 + progress * 0.04})`;
      ticking = false;
    };
    window.addEventListener('scroll', () => {
      if (!ticking) {
        window.requestAnimationFrame(updateParallax);
        ticking = true;
      }
    }, { passive: true });
    updateParallax();
  }

  // Nav gains a glass blur once scrolled past the first viewport
  let navTicking = false;
  const updateNavState = () => {
    root.classList.toggle('is-scrolled', window.scrollY > 80);
    navTicking = false;
  };
  window.addEventListener('scroll', () => {
    if (!navTicking) {
      window.requestAnimationFrame(updateNavState);
      navTicking = true;
    }
  }, { passive: true });
  updateNavState();
})();
